export type ShiftTasksSummary = {
  open: number
  overdue: number
  done: number
}

export type MyTasksSummary = ShiftTasksSummary

export enum TaskSource {
  EASY_POM = 'easyPOM',
  COCKPIT = 'cockpit',
  PROCESS_WORK_ORDER = 'processWorkOrders',
  MACHINE_SENTRY_ACTIONS = 'machineSentryActions',
  OIL_ANALYSIS_ACTIONS = 'oilAnalysis',
  DALOG_ACTIONS = 'dalogActions'
}
